<template>
  <div >
    <v-toolbar flat color="white" class= "pt-3">
      <h1 class="heading dark-grey--text px-2 py-2">Tag: {{tagInfo.tagCode}}</h1>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('accessPointGroups')">
      <accesspointgroupscomponent
      @fetchGroups="fetchAccessPointGroups()"
      :accesspointgroupsinfo="accessPointGroups"
      :tagId="this.$route.params.tagId"
      :isloading="isLoading"
    ></accesspointgroupscomponent>
    </div>
  <div v-if="displayContents('contacts')">
     <v-card style="min-height:100vh" flat>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container grid-list-xs>
      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <v-card-text>
            <h2 class="dark-grey--text font-weight-bold">Basic Contact Information</h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="contactInfo.name"
                    :readonly="true"
                    label="Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
              <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="contactInfo.surname"
                     :readonly="true"
                    label="Surname"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
               <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="contactInfo.idNumber"
                     :readonly="true"
                    label="ID Number"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="contactInfo.mobileNumber"
                     :readonly="true"
                    label="Mobile Number"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="contactInfo.emailAddress"
                     :readonly="true"
                    label="Email Address"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
            
              </v-layout>
            </v-container>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
      </v-card>
 
  </div>
   <div v-if="displayContents('accessTransactionLogs')">
      <accesstransactionlogscomponent
       @fetchLogs="fetchAccessTransactionLogs()"
      ></accesstransactionlogscomponent>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import AccessPointGroups from "@/components/AccessPointGroups.vue";
import AccessTransactionLogs from "@/components/AccessTransactionLogs.vue";

export default {
  props: ["tagsummary", "totalitems"],
  components: {
     accesspointgroupscomponent: AccessPointGroups,
     accesstransactionlogscomponent: AccessTransactionLogs
  },
  data() {
    return {
      tagInfo: [],
      contactInfo: [],
      accessPointGroups: [],
      accessTransactionLogs: [],
            associateDialog: false,
            name: "",
            isloading:true,
            loading: false, 
            expand: false,
            search: "",
            dialog: false,
            newDialog: false,
            pagination: {},
            editedIndex: -1,
            editedItem: {
            
    },
    defaultItem: {
     
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ],
      activeTabName:'',
      tabs: [        
        { name: "contacts", displayName: "Contacts" },
        { name: "accessPointGroups", displayName: "Access Point Groups" },
        { name: "accessTransactionLogs", displayName: "Access Transaction Logs" }             
      ]
    };
  },
  created() {
    this.initialize();
  },
  async mounted() {
      this.setActiveTabName('contacts')
  },
  computed: {
         pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
    },
  methods: {
     fetchAccessTransactionLogs(){
      Api()
        .get("/accessTransactionLogs/showByTag/" + this.$route.params.tagId)
        .then(response => {
          this.accessTransactionLogs = response.data;
        });
    },
    fetchAccessPointGroups(){
      this.accessPointGroups = [];
       Api()
        .get("/accessPointGroupTags/getAccessPointGroups/" + this.$route.params.tagId)
        .then(response => {
          for(let index=0; index< response.data.length; index++){
          this.accessPointGroups.push(response.data[index].accessPointGroup);
         }
          this.isloading =false
        });
      },
    getTagInfo() {
      Api()
        .get("/tags/getOne/" + this.$route.params.tagId)
        .then(response => {
          this.tagInfo = response.data;
          this.contactInfo = response.data.contact
        });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    
    initialize() {
      this.getTagInfo();
      this.fetchAccessTransactionLogs();
      this.fetchAccessPointGroups();   
    },  
         
  }
};
</script>
